import { gql } from '@apollo/client'
import { SIMPLE_PRODUCT_FRAGMENT } from '../fragments/SimpleProductFragment'

export const GET_PRODUCT_BY_UPC = gql`
  query GetProductByUpc($upc: ID!) {
    productByUpc(upc: $upc) {
      ...SimpleProduct
    }
  }
  ${SIMPLE_PRODUCT_FRAGMENT}
`
